import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createRef, Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import compose from 'recompose/compose';
import { apiGetNews as apiGetNewsAction } from '../../actions/NewsActions';
import OtherClickListener from '../../events/OtherClickListener';
import { propArrayShape, propFunc, propShape, } from '../../helpers/custom-prop-types';
class HeaderNotificationButton extends Component {
    constructor(props) {
        super(props);
        this.hideBody = () => {
            this.setState({ isOpen: false });
        };
        this.toggleBody = () => {
            const { isOpen } = this.state;
            this.setState({ isOpen: !isOpen });
        };
        this.clickRef = createRef();
        this.clickListenerNo = null;
        this.state = {
            isOpen: false,
        };
    }
    componentDidMount() {
        const { apiGetNews } = this.props;
        apiGetNews();
        this.clickListenerNo = OtherClickListener.setListener(this.clickRef.current, this.hideBody);
    }
    componentWillUnmount() {
        OtherClickListener.deleteListener(this.clickListenerNo);
    }
    render() {
        const { list, profile } = this.props;
        const { isOpen } = this.state;
        return (_jsxs("div", Object.assign({ className: `menu-icon info ${isOpen ? 'active' : ''}` }, { children: [_jsx("button", Object.assign({ className: 'material-icons hov-icon', disabled: !profile.id, onClick: this.toggleBody, ref: this.clickRef, tabIndex: '-1', type: 'button' }, { children: "notifications_active" })), _jsx("div", Object.assign({ className: `info-menu icon-menu-body ${isOpen ? 'is-visible' : ''}`, onClick: this.toggleBody, role: 'presentation' }, { children: _jsxs("dl", { children: [list.length === 0 && _jsx("em", { children: "\u304A\u77E5\u3089\u305B\u306F\u3042\u308A\u307E\u305B\u3093" }), list.length > 0 &&
                                list.map((model) => (_jsxs(Fragment, { children: [_jsxs("dt", { children: [model.createdAt, model.readAt ? null : (_jsx("span", Object.assign({ className: 'font-warning' }, { children: "New" })))] }), _jsxs("dd", { children: [model.action && (_jsx(Link, Object.assign({ to: model.action }, { children: model.content }))), !model.action && model.content] })] }, model.id)))] }) }))] })));
    }
}
HeaderNotificationButton.propTypes = {
    apiGetNews: propFunc().isRequired,
    list: propArrayShape().isRequired,
    profile: propShape().isRequired,
};
const mapStateToProps = ({ news, profile }) => ({
    list: news.list.slice(0, 20),
    profile,
});
const mapDispatchToProps = (dispatch) => ({
    apiGetNews: () => dispatch(apiGetNewsAction()),
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(HeaderNotificationButton);
